import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Divider, Stack, Typography } from "@mui/material";
import React from "react";
const InfosBlock = (props) => {
    const { id, title, items } = props;
    return (_jsx(Box, { sx: {
            p: { xs: "28px", md: "40px" },
            backgroundColor: "background.grey",
            height: "fit-content",
        }, children: _jsxs(Stack, { spacing: 4, children: [title && (_jsxs(Stack, { spacing: 4, children: [_jsx(Typography, { variant: "h5", component: "h3", sx: {
                                color: "text.primary",
                                fontWeight: 600,
                            }, children: title }), _jsx(Divider, { sx: { backgroundColor: "border.default", margin: 0 } })] })), items && (_jsx(Box, { sx: {
                        width: "100%",
                        "& ul": {
                            display: "flex",
                            flexDirection: "column",
                            gap: "8px",
                            margin: 0,
                        },
                    }, children: items }))] }) }, id));
};
export default InfosBlock;
